
export const responseLoad = function () {
    return new Promise(function (resolve, reject) {
        window.responseLoadTries = 0;
        const responseLoadInterval = setInterval(() => {
            try {
                window.responseLoadTries++;
                showResults(Scan.responseJSON);
                clearInterval(responseLoadInterval);
                resolve(true);
            } catch (error) {
                console.error(error);
                if (window.responseLoadTries > 20) {
                    clearInterval(responseLoadInterval);
                    reject(error);
                }
            }
        }
            , 100);
    });
};

export const scanLoad = function () {
    return new Promise(function (resolve, reject) {
        window.scanLoadTries = 0;
        const scanLoadInterval = setInterval(() => {
            try {
                window.scanLoadTries++;
                window.Scan = new CopeWebScan(); // loaded from external file
                window.Scan.runAll();
                clearInterval(scanLoadInterval);
                resolve(true);
            } catch (error) {
                console.error(error);
                if (window.scanLoadTries > 20) {
                    clearInterval(scanLoadInterval);
                    reject(error);

                }
            }

        }, 100);
    }
        , 100);
}